// @workflow assistant.voice, assistant.attachments
/**
 * The API base and the user's auth for the assistant's REST clients (dictation, Read aloud), in
 * one place: the clients take these as their injected deps (authedFetch.js).
 */
import config from '@/../appConfig';
import { $getAuthHeaders } from '@/utils';
import { refreshAuth } from '@Assistant/services/agentClient';

export const API_AUTH = Object.freeze({
  baseUrl: config.API_URL,
  getHeaders: () => $getAuthHeaders(),
  refreshAuth,
});
